"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M17.094 8.038a3.216 3.216 0 00-2.189-.838c-.792 0-1.583.28-2.188.838L12 8.702l-.717-.664A3.218 3.218 0 009.095 7.2c-.793 0-1.585.28-2.189.838-1.207 1.117-1.208 2.927-.003 4.045L11.99 16.8l.01-.01.01.01 5.087-4.717c1.205-1.119 1.204-2.928-.003-4.045z" }), "Heart");
//# sourceMappingURL=Heart.js.map